import { format, subDays, subMonths } from "date-fns";
import { toZonedTime } from "date-fns-tz";

const DAYS_BACK: Record<string, number> = { "7days": 7, "30days": 30, "90days": 90 };

// The report's first and last day ("yyyy-MM-dd") as the shop's calendar days. They came from
// toISOString(), the UTC date, so after 5 PM in a Pacific shop "Last 7 days" ran a day ahead.
export function quickRange(timeframe: string, now: Date, timeZoneId: string) {
    const today = toZonedTime(now, timeZoneId); // fields hold the shop's wall clock
    const start = timeframe === "12months" ? subMonths(today, 12) : subDays(today, DAYS_BACK[timeframe] ?? 7);
    return { startDate: format(start, "yyyy-MM-dd"), endDate: format(today, "yyyy-MM-dd") };
}
